import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import echarts from 'echarts/lib/echarts'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

import * as filters from './filters' // 全局 filters
import '@/style/main.scss'// css
import '@/style/nprogress.scss'// css
import '@/config/rem'// rem
import '@/assets/scss/common.scss'

// svgIcon
import "@/assets/svgIcon/index";
// 全局组件
import '@/common/js/globalComponent'

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

/* 路由发生改变修改页面的title */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title || ''
  }

  NProgress.start()
  store.dispatch('user/checkLogin')
    .then(() => {
      next()
    })
    .catch(() => {
      if (to.meta.needLogin) {
        next('/login')
      } else {
        next()
      }
    })
})
router.afterEach(() => {
  window.scrollTo(0, 0)
  NProgress.done() // 结束Progress
})

// 注册全局 filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
